<div class="body-estruct" loader [switch]="loader">
    <div class="banner"
    [ngStyle]="{'background-color': '#F5F5F5', 'background-image' : getImage(), 'background-repeat': 'no-repeat', 'background-size': getCover() } ">
    <app-toolbar (productItemEvent)="addItem($event)"
    (quoteItemEvent)="addItem($event)"
    (benefitsItemEvent)="addItem($event)"
  ></app-toolbar>
    <div class="container banner-bg-height">
      <div class="row">
        <div class="col-12 d-block d-lg-none col-lg-6 align-self-center py-20x">
          <div class="row">
            <div>
              <img class="logoCoche" src="./assets/images/banner/coche seguro.svg" width="200px" height="110px" />
            </div>
            <div class="col-12 text-center">
              <h1 class="white text-left" style="font-size: 32px">Seguro,seguro</h1>
            </div>
            <div class="col-12 text-center">
              <h1 class="white text-left" style="font-size: 20px"> Te ayudamos a contratar el seguro ideal para ti, garantizándote la mejor experiencia, al mejor precio del mercado.</h1>
            </div>
          </div>
        </div>
        <div class="col-12 d-none d-lg-block col-lg-6  align-self-center">
          <div class="row">
            <div>
              <img class="logoCoche" src="./assets/images/banner/coche seguro.svg" width="200px" height="110px" />
            </div>
            <div class="col-12 text-center">
              <h1 class="white text-left" style="font-size: 64px">Seguro,seguro</h1>
            </div>
            <div class="col-12 text-center">
              <h1 class="white text-left" style="font-size: 32px"> Te ayudamos a contratar el seguro ideal para ti, garantizándote la mejor experiencia, al mejor precio del mercado.</h1>
            </div>
          </div>
        </div>
        <div #cotizador class="col-12 col-lg-6">
          <div class="card-auto mat-elevation-z2" [class.paddingLimit]="isMobile">
            <form action="" id="form1" name="form-inicio">
              <div class="table-sio w-100">
                <div class="row-sio">
                  <div class="cell-sio text-center">
                    <h1 class="titulo my-0x">Buscamos un seguro para ti <br/>seguro, seguro</h1>
                  </div>
                </div>
                <div class="row-sio">
                  <div class="cell-sio">
                    <h6 class="mejor-servicio my-0x" style="font-size: 16px;color: #C7C7C7;">DATOS DEL ASEGURADO</h6>
                  </div>
                </div>
                <div class="row-sio">
                  <div class="cell-sio">
                    <input type="text" name="nombre" id="txNombre" placeholder="Nombre" autocomplete="off" [class.input-custom-cp-error]="nombreInvalid" 
                      [(ngModel)]="prospecto.nombre"  (keypress)="limiteLetras($event, 20)" [disabled]="prospecto.logeado" (focus)="focusNombre($event)" autofocus />
                  </div>
                </div>
                <div class="row-sio">
                  <div id="correo" class="cell-sio">
                    <fieldset [disabled]="prospecto.logeado" class="fieldset w-100 p-0x">
                      <div class="d-flex justify-content-end align-items-center">
                        <mat-icon style="position: absolute;"  class="icoInfo" #tooltipEmailMovil="matTooltip"
                        matTooltipClass="tool-tip" (click)="tooltipEmailMovil.toggle()"
                        matTooltip="Tu correo correcto facilita la compra." matTooltipPosition='right'>info</mat-icon>
                      </div>
                      <input type="text" name="correo" id="txCorreo" class="lowercase" [class.input-custom-error]="!correoValido" placeholder="Correo electrónico"
                        autocomplete="off" maxlength="80" [formControl]="correo" (blur)="validarCorreo()" (focus)="focusEmail($event)"/>
                      </fieldset>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                  <div class="col-6 col-md-6 col-xl-6 px-xs-6x" >
                    <div id="telefono">
                      <fieldset [disabled]="prospecto.logeado" class="fieldset w-100 p-0x"> 
                        <div class="d-flex justify-content-end align-items-center">
                          <mat-icon style="position: absolute;"  class="icoInfo" #tooltipPhoneMobile="matTooltip"
                          matTooltipClass="tool-tip" (click)="tooltipPhoneMobile.toggle()"
                          matTooltip="Tu teléfono nos permite mantener la comunicación contigo." matTooltipPosition='right'>info</mat-icon>
                        </div>
                        <input type="text" [class.input-custom-error]="!numeroValido" name="celular" id="txCelular" placeholder="Celular" autocomplete="off"
                           [(ngModel)]="celular" (blur)="validPhoneNumber()" (keypress)="keyPressSoloNumeros($event)" (focus)="focusPhoneNumber($event)" maxlength="10" />
                      </fieldset>
                    </div>
                  </div>
                  <div class="col-6 col-md-6 col-xl-6 px-xs-6x" >
                    <div class="text-right fieldset w-100 p-0x">
                      <div>
                        <div>
                          <div class="d-flex justify-content-end align-items-center">
                            <mat-icon style="position: absolute;"  class="icoInfo" #tooltipAgeMobile="matTooltip"
                            matTooltipClass="tool-tip" (click)="tooltipAgeMobile.toggle()"
                            matTooltip="Tu edad correcta es importante para la contratación." matTooltipPosition='right'>info</mat-icon>
                          </div>
                          <input type="text" [imask]="edadMask" class="txEdad" name="edad" id="txtEdad" [(ngModel)]="edad" (blur)="verificaEdad()" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                  <div class="col-6 col-md-6 col-xl-6 px-xs-6x" >
                    <input type="text" name="CP" id="txCP" placeholder="CP" [class.input-custom-cp-error]="cpInvalid" maxlength="5" autocomplete="off"
                        (blur)="validaCodigoPostal($event.target.value)" (keypress)="keyPressSoloNumeros($event)" (focus)="focusCP($event)" [(ngModel)]="prospecto.cp"
                        [disabled]="prospecto.logeado" autofocus />
                  </div>
                  <div class="col-6 col-md-6 col-xl-6 px-xs-6x" >
                    <div class="text-right fieldset w-100 p-0x" style="margin-top: 10px;">
                      <div>
                        <div>
                          <div class="cell-sio  px-5x">
                            <input type="radio" id="m" name="sexo" value="1" (click)="sexo=1">
                            <label for="m">Hombre</label>
                          </div>
                          <div class="cell-sio  px-5x">
                            <input type="radio" id="f" name="sexo" value="0" (click)="sexo=0">
                            <label for="f">Mujer</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row-sio">
                  <div class="cell-sio">
                    <h6 class="mejor-servicio my-0x" style="font-size: 16px;color: #C7C7C7;">DATOS DEL VEHÍCULO</h6>
                  </div>
                </div>
                <div>
                  <div class="row-sio">
                    <div class="cell-sio">
                      <div class="row-sio">
                        <div class="cell-sio text-middle w-60 text-right">
                          <label for="credito" style="font-weight: 400; font-size: 14px; font-style: italic; margin-right: 10px;">
                            <input type="radio" name="tipo-tarjeta" id="credito"
                              value="datosCotizacion.multicotiza.f7" (click)="cambioVehiculo(0)" checked />
                            <span class="label">AUTO</span>
                          </label>
                          <label for="debito" style="font-weight: 400; font-size: 14px; font-style: italic; margin-right: 10px;">
                            <input type="radio" name="tipo-tarjeta" id="debito"
                              value="datosCotizacion.multicotiza.f7" (click)="cambioVehiculo(1)" />
                            <span class="label">PICKUP</span>
                          </label>
                          <label for="debito" style="font-weight: 400; font-size: 14px; font-style: italic;">
                            <input type="radio" name="tipo-tarjeta" id="debito"
                              value="datosCotizacion.multicotiza.f7" (click)="cambioVehiculo(9)" />
                            <span class="label">MOTO</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row-sio" style="margin-top: 10px;">
                    <div class="cell-sio w-30">
                      <select placeholder="Modelo" name="modelo" id="cbModelo"
                        [(ngModel)]="datosCotizacion.multicotiza.f4" class="m-auto"
                        (change)="verificaModelo($event.target.value)" style="font-size: 12px;">
                        <option value="null">Modelo</option>
                        <option *ngFor="let modelo of modelos" [value]="modelo.c1">{{modelo.c1}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="table-sio w-100">
                    <div class="row-sio">
                      <div class="cell-sio">
                        <select class="custom-select" name="marca" id="marca" required placeholder="Marca"
                          aria-placeholder="Marca" (change)="verificaMarca()"
                          [(ngModel)]="datosCotizacion.multicotiza.f8" style="font-size: 12px;">
                          <option selected value="">Marca</option>
                          <option *ngFor="let marca of marcas" [value]="marca.c1">{{marca.c2}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row-sio">
                      <div class="cell-sio">
                        <select class="custom-select" name="tipo" id="tipo" required placeholder="Tipo"
                          aria-placeholder="Tipo" (change)="verificaTipo($event.target.value)"
                          [(ngModel)]="datosCotizacion.multicotiza.f9" style="font-size: 12px;">
                          <option selected value="">Tipo</option>
                          <option *ngFor="let tipo of tipos" [value]="tipo.c1">{{tipo.c1}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row-sio">
                      <div class="cell-sio">
                        <select class="custom-select" name="descripciones" id="vehiculo" required placeholder="Vehículo"
                          aria-placeholder="Vehículo" (change)="verificaDescripcion($event.target.value)"
                          [(ngModel)]="datosCotizacion.multicotiza.f3" style="font-size: 12px;">
                          <option selected value="">Descripción</option>
                          <option *ngFor="let veh of descripciones" [value]="veh.c1">{{veh.c2}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row-sio">
                  <div class="cell-sio text-center">
                    <button mat-flat-button name="cotizaciones" id="btnCotizaciones" class="w-100"
                      [color]="styleCocheSeguro?.colorBtn" [disabled]="openCot" (click)="next()" style="background: #039ECC">BUSCAR UN SEGURO <label></label></button>
                  </div>
                </div>
                <div class="row-sio">
                  <div class="cell-sio text-center">
                    ¿Eres conductor de alguna app de transporte? <a href="https://driver.inter.mx/" target="_blank" style="color: #039ECC">Cotiza aquí</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="col-12 col-lg-6 text-center">
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
    <div class="slider" style="display: flex;">
      <div class="slide-track">
        <div class="slide">
          <img class="ciaChubb" src="./assets/images/cias/chubb.svg" alt="CHUBB" />
        </div>
        <div class="slide">
          <img class="ciaQualitas" src="./assets/images/cias/Qualitas.svg" alt="QUALITAS" />
        </div>
        <div class="slide">
          <img class="ciaAxa" src="./assets/images/cias/axa.svg" alt="AXA"/>
        </div>
        <div class="slide">
          <img class="ciaAfirme" src="./assets/images/cias/Afirme.svg" alt="AFIRME"/>
        </div>
        <div class="slide">
          <img class="ciaHdi" src="./assets/images/cias/HDI.svg" alt="HDI"/>
        </div>
        <div class="slide">
          <img class="ciaPrimeroSeguros" src="./assets/images/cias/Primero.svg" alt="PRIMERO" />
        </div>
        <div class="slide">
          <img class="ciaMapfre" src="./assets/images/cias/MAPFRE.svg" alt="MAPFRE" />
        </div>
        <div class="slide">
          <img class="ciaGNP" src="./assets/images/cias/gnp (1).svg" alt="GNP"/>
        </div>
      </div>
      <div class="slide-track">
        <div class="slide">
          <img class="ciaChubb" src="./assets/images/cias/chubb.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaQualitas" src="./assets/images/cias/Qualitas.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaAxa" src="./assets/images/cias/axa.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaAfirme" src="./assets/images/cias/Afirme.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaHdi" src="./assets/images/cias/HDI.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaPrimeroSeguros" src="./assets/images/cias/Primero.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaMapfre" src="./assets/images/cias/MAPFRE.svg" alt="" />
        </div>
        <div class="slide">
          <img class="ciaGNP" src="./assets/images/cias/gnp (1).svg" alt="" />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid body-inicio">
    <div class="row">
      <div class="col-12">
        <div class="container otros-seguros">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <h1 class="gray">¿Por qué INTER?</h1>
              <br />
              <br />
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="cubo-inter">
                <div class="row-sio">
                  <div class="cell-sio text-middle">
                    <img class="imgBienSeguro" src="./assets/images/Siempre a tu lado.svg" alt=""width="200px" height="110px"/>
                  </div>
                  <div style="color: #039ECC;font-size: 20px !important;font-weight: bold;text-align: left;">
                    Siempre a tu lado
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    Vive una experiencia personalizada y disfruta la tranquilidad de sentirte protegido, escuchado y <b>respaldado de principio a fin</b>.
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="cubo-inter">
               <div class="row-sio">
                  <div class="cell-sio text-middle">
                    <img class="imgBienSeguro" src="./assets/images/Encuentra el mejor seguro.svg" alt=""width="200px" height="110px"/>
                  </div>
                  <div style="color: #039ECC;font-size: 20px !important;font-weight: bold;text-align: left;">
                    Encuentra el mejor seguro
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    Cotiza con las aseguradoras líderes y obtén el <b>mejor plan al mejor precio</b>, de forma fácil, rápida y segura.
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="cubo-inter">
                <div class="row-sio">
                  <div class="cell-sio text-middle">
                    <img class="imgBienSeguro" src="./assets/images/Personaliza tu seguro.svg" alt="" width="200px" height="110px"/>
                  </div>
                  <div style="color: #039ECC;font-size: 20px !important;font-weight: bold;text-align: left;">
                    Personaliza tu seguro
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    Elige la mejor <b>cobertura</b> para ti y la forma de <b>pago que más se ajuste a tus necesidades</b>. 
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <div class="cubo-inter">
                <div class="row-sio">
                  <div class="cell-sio text-middle">
                    <img class="imgBienSeguro" src="./assets/images/Tus seguros en un solo lugar.svg" alt="" width="200px" height="110px" />
                  </div>
                  <div style="color: #039ECC;font-size: 20px !important;font-weight: bold;text-align: left;">
                    Tus seguros en un sólo lugar
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    Contrata en línea tu seguro y <b>obtén tu póliza</b> en minutos <b>llevándolas siempre contigo en nuestra app</b>.
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bannercs container-fluid body-inicio">
    <div class="row">
      <div class="col-12">
        <div class="container">
          <ng-container *ngIf="isInterMX">
            <div class="slider-checo" *ngIf="isMobile; else desktop">
              <img src="../../assets/images/banner/bannersweb_promo_amazon_azul_360x300.png" class="size-100" alt="">
            </div>
            <ng-template #desktop>
              <div class="mt-2">
                <img src="../../assets/images/banner/bannersweb_promo_amazon_azul_1140x300.png" class="size-100" alt="">
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid body-inicio">
    <div class="row">
      <div class="col-12">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <h1 class="gray">Coberturas a prueba de todo</h1>
              <br />
              <br />
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="cubo-cobertura">
                <div class="row-sio">
                  <div style="font-size: 20px !important;font-weight: bold;text-align: left;">
                    Amplia
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%" />  Daños Materiales<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>Robo Total<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Responsabilidad civil<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Gastos Médicos<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Defensa Legal<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Asistencia en viajes<br/>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="cubo-cobertura">
               <div class="row-sio">
                  <div style="font-size: 20px !important;font-weight: bold;text-align: left;">
                    Limitada
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    <img class="coverage" src="./assets/images/NoIncluded.svg" alt="" width="10%"/>  Daños Materiales<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>Robo Total<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Responsabilidad civil<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Gastos Médicos<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Defensa Legal<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Asistencia en viajes<br/>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="cubo-cobertura">
                <div class="row-sio">
                  <div style="font-size: 20px !important;font-weight: bold;text-align: left;">
                    Basica
                    <br />
                    <br />
                  </div>
                  <div style="text-align: left;">
                    <img class="coverage" src="./assets/images/NoIncluded.svg" alt="" width="10%"/>  Daños Materiales<br/>
                    <img class="coverage" src="./assets/images/NoIncluded.svg" alt="" width="10%"/>Robo Total<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Responsabilidad civil<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Gastos Médicos<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Defensa Legal<br/>
                    <img class="coverage" src="./assets/images/Included.svg" alt="" width="10%"/>  Asistencia en viajes<br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br/><br/>
  <div class="container-fluid body-inicio">
    <div class="row">
      <div class="col-12">
        <div class="container" style="background: #FFFFFF !important">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <h1 class="gray">¿Quieres proteger algo más?</h1>
              <p style="font-size:18px;">Tenemos estos seguros pensados en ti</p>
              <br />
              <br />
            </div>
            <ng-container>
            <div class="slider-checo" *ngIf="isMobile; else desktopr">
              <div class="slide-track">
                <div class="slide" >
                  <img class="imgBienSeguro" src="./assets/images/otros/Bien Seguro.svg" alt="" (click)="openWin(1)" />
                </div>
                <div class="slide">
                  <img class="imgBienSeguro" src="./assets/images/otros/Medico_Seguro.svg" alt="" (click)="openWin(2)" />
                </div>
                <div class="slide">
                  <img class="imgBienSeguro" src="./assets/images/otros/Mascota Segura.svg" alt="" (click)="openWin(3)" />
                </div>
                <div class="slide">
                  <img class="imgBienSeguro" src="./assets/images/otros/Viaja Seguro.svg" alt="" (click)="openWin(4)" />
                </div>
                <div class="slide">
                  <img class="imgBienSeguro" src="./assets/images/otros/Vida Segura.svg" alt="" (click)="openWin(5)" />
                </div>
              </div>
            </div>
            <ng-template #desktopr>
              <div class="col-12 col-md-6 col-lg-2" (click)="openWin(1)">
                <div class="cubo-seguros">
                  <div >
                    <img class="imgBienSeguro" src="./assets/images/otros/Bien Seguro.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-2" (click)="openWin(2)">
                <div class="cubo-seguros">
                  <div>
                    <img class="imgBienSeguro" src="./assets/images/otros/Medico_Seguro.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-2" (click)="openWin(3)">
                <div class="cubo-seguros">
                  <div >
                    <img class="imgBienSeguro" src="./assets/images/otros/Mascota Segura.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-2" (click)="openWin(4)">
                <div class="cubo-seguros">
                  <div>
                    <img class="imgBienSeguro" src="./assets/images/otros/Viaja Seguro.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-2" (click)="openWin(5)">
                <div class="cubo-seguros">
                  <div>
                    <img class="imgBienSeguro" src="./assets/images/otros/Vida Segura.svg" alt="" />
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
          </div>
          <br/><br/>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid body-inicio">
    <div class="row">
      <div class="col-12">
        <br/><br/><br/><br/>
      </div>
    </div>
  </div>
  <div class="row float-right mx-0x" *ngIf="!isMobile">
    <div class="col-12 py-20x">
      <button mat-flat-button class="btn-ayuda font-ayuda ocultar-btn floating_button_sirena" 
        (click)="guardarRegistroInicioAyuda()">
        <mat-icon>phone</mat-icon> ¿Necesitas Ayuda?
      </button>
    </div>
  </div>
</div>
<ng-template #popExplorer>
  <div class = "row px-md-20 header" style="max-width: 380px; max-height: 175px">
      <div>
        <p class="centrado">
          La aplicación no es compatible con <strong>Internet Explorer</strong>,
          intentelo con los siguientes navegadores:
        </p>
          <p class="centrado">
            <img src="../../assets/images/logos/navega/chrome.png"  alt="chrome" title="Chrome">
            <img src="../../assets/images/logos/navega/firefox.jpg"  alt="firefox" title="firefox">
            <img src="../../assets/images/logos/navega/safari.png"  alt="safari" title="safari">
          </p>
      </div>
  </div>
</ng-template>
<div #servicios></div>
<app-footer ></app-footer>

